import { FC } from 'react';

import HeartOutlined from 'dibs-icons/exports/HeartOutlined';
import PdpSharedAuctionsWatchWrapper from './PdpSharedAuctionsWatchWrapper';

import styles from './PdpSharedAuctionsWatch.scss';

type Props = {
    buttonSize: 'small' | 'medium' | 'large';
};

export const PdpSharedAuctionsWatchLoading: FC<Props> = ({ buttonSize }) => {
    return (
        <PdpSharedAuctionsWatchWrapper
            buttonSize={buttonSize}
            heartIcon={<HeartOutlined className={styles.iconWrapper} />}
            isLoading
        />
    );
};
